import { combineEpics } from 'redux-observable'
import authEpics from './auth/epics'
import userEpics from './User/epics'
import companyEpics from './company/epics'

const epics = [...authEpics, ...userEpics, ...companyEpics]
const rootEpic = combineEpics(...epics)
export default rootEpic
